module.exports = __webpack_public_path__ + "static/media/Mapa-Amapá.a0a75fb7.svg";